export default __webpack_public_path__ + "static/media/laptopImage.81a475d7.png";